import { TextField } from "@mui/material"
import numeral from "numeral"
import React, { useEffect, useRef, useState } from "react"
import { formatPrice } from "utils/parsers/prices"

export const PriceInputCell = ({
  name,
  initialValue,
  onChangeAsync,
  ...rest
}) => {
  const [value, setValue] = useState(initialValue)
  const [focused, setFocused] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const ref = useRef(null)
  const focusedRef = useRef(false)

  useEffect(() => {
    let mounted = true
    if (mounted && !focusedRef.current) {
      setValue(initialValue)
      setError(false)
    }

    return () => {
      mounted = false
    }
  }, [initialValue])

  const handleUpdate = () => {
    if (initialValue !== value) {
      setLoading(true)
      setError(false)
      onChangeAsync(value)
        .catch(() => {
          setError(true)
          setValue(initialValue)
        })
        .finally(() => setLoading(false))
    }
  }

  const formattedValue =
    numeral(value).value() !== null ? formatPrice(value) : ""
  const displayValue = focused ? value ?? "" : formattedValue

  return (
    <TextField
      name={name}
      inputRef={ref}
      disabled={loading}
      error={error}
      value={displayValue}
      onChange={(e) => setValue(e.target.value)}
      onInput={() => setError(false)}
      onFocus={() => {
        focusedRef.current = true
        setFocused(true)
      }}
      onKeyUp={(e) => {
        if (e.key === "Enter" && ref.current?.blur) {
          ref.current.blur()
        }
      }}
      onBlur={() => {
        focusedRef.current = false
        setFocused(false)
        handleUpdate()
      }}
      inputProps={{ sx: { textAlign: "right" } }}
      {...rest}
    />
  )
}
